var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenAiIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3125_10909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9608 13.3465L8.619 11.8388C9.20482 10.4972 10.2592 9.42921 11.5744 8.84541L13.3862 8.04118C13.9622 7.78551 13.9622 6.94752 13.3862 6.69183L11.6309 5.91271C10.2819 5.3139 9.20865 4.20636 8.63287 2.81896L7.96613 1.2123C7.7187 0.61608 6.89489 0.616082 6.64748 1.2123L5.9807 2.81895C5.40493 4.20636 4.33165 5.3139 2.98264 5.91271L1.22743 6.69183C0.651402 6.94752 0.651402 7.78551 1.22743 8.04118L3.03922 8.84541C4.35442 9.42921 5.40878 10.4972 5.99456 11.8388L6.6528 13.3465C6.90582 13.9259 7.70775 13.9259 7.9608 13.3465ZM14.5511 17.0172L14.7362 16.5929C15.0662 15.8365 15.6605 15.2341 16.4021 14.9047L16.9724 14.6512C17.2809 14.5142 17.2809 14.0659 16.9724 13.9289L16.4341 13.6897C15.6734 13.3517 15.0683 12.7271 14.744 11.9449L14.5539 11.4865C14.4214 11.167 13.9796 11.167 13.8471 11.4865L13.6571 11.9449C13.3328 12.7271 12.7277 13.3517 11.967 13.6897L11.4286 13.9289C11.1202 14.0659 11.1202 14.5142 11.4286 14.6512L11.9989 14.9047C12.7406 15.2341 13.3349 15.8365 13.6649 16.5929L13.85 17.0172C13.9855 17.3278 14.4155 17.3278 14.5511 17.0172Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3125_10909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenAiIconDark);
export default __webpack_public_path__ + "static/media/gen-ai-icon-dark.1ef7625b47ec1a7405f329c27e62fbfa.svg";
export { ForwardRef as ReactComponent };